import React from 'react';
import { useState } from 'react';
// import { BsFacebook, BsInstagram, BsWhatsapp } from 'react-icons/bs';
// import { RiMenu3Line } from 'react-icons/ri';
// import { AiOutlineClose } from 'react-icons/ai';
import logo from '../../assets/img/logo.png';
import '../style.css';
// import { Link } from 'react-router-dom';

const NavBar = () => {   
	const [ nav, setNav ] = useState(true);
	const handleNav = () => {
		setNav(!nav);
	};
	return (
		<div>
			<div className="w-full h-2 bg-blue-500 z-50 relative"> </div>
			<div className="sticky top-0 flex justify-center  h-20 max-w-fill mx-auto  bg-white  shadow-md ">
				<div className="flex items-center  ">
					<h1 className="text-3xl">      
						<img className="w-72 object-fill" src={logo} alt="" />
					</h1>
				</div>

				{/* <div className="text-teal-600 flex items-center">
					<ul className="hidden md:flex font-['Fira Sans']">
						<li className="px-4 py-1 capitalize font-normal cursor-pointer focus:text-cyan-400 hover:text-cyan-400 hover:ease-in-out delay-50 duration-300 mx-1  hover:bg-teal-600 hover:text-white  hover:rounded-full">
							{' '}
							<Link to="/" >
								Home
							</Link>
						</li>
						<li className="px-4 py-1 capitalize font-normal cursor-pointer focus:text-cyan-400 hover:text-cyan-400 hover:ease-in-out delay-50 duration-300 mx-1   hover:bg-teal-600 hover:text-white  hover:rounded-full">
							<Link to="/about">
								About
							</Link>
						</li>
						<li className="px-4 py-1 capitalize font-normal cursor-pointer focus:text-cyan-400 hover:text-cyan-400 hover:ease-in-out delay-50 duration-300 mx-1   hover:bg-teal-600 hover:text-white  hover:rounded-full">
						<Link to="/ourservice">
								Our Service
							</Link>
						</li>
						<li className="px-4 py-1 capitalize font-normal cursor-pointer focus:text-cyan-400 hover:text-cyan-400 hover:ease-in-out delay-50 duration-300mx-1  mx-1 hover:bg-teal-600 hover:text-white  hover:rounded-full">
						<Link to="/contact">
								Contact
							</Link>
						</li>
					</ul>
				</div> */}
				{/* <div className="flex items-center hidden md:flex">
					<ul className="flex ">
						<li className=" px-2 text-2xl text-blue-800">
							<BsFacebook />
						</li>
						<li className=" px-2 text-2xl text-red-500 ">
							<BsInstagram />
						</li>
						<li className=" px-2 text-2xl text-green-600 ">
							<BsWhatsapp />
						</li>
					</ul>
				</div> */}
				{/* <div className="flex items-center  z-50">
					<div className="block md:hidden" onClick={handleNav}>
						{!nav ? <AiOutlineClose fontSize={20} /> : <RiMenu3Line fontSize={20} />}
					</div>
				</div>
				<div
					className={
						!nav ? (
							'fixed left-0 top-0 w-60 h-full bg-slate-50 mt-2 text-teal-600  ease-in-out delay-150 duration-500 block md:hidden'
						) : (
							'fixed left-[-100%] top-0 mt-2 ease-in-out duration-700'
						)
					}
				>
					<div className="flex justify-center mx-auto pt-1">
						<img className=" w-44 object-fill" src={logo} alt="" />
					</div>

					<ul className="pt-2">
						<li className="p-4 uppercase font-medium border-b border-slate-300"><Link to="/" >
								Home
							</Link></li>
						
					</ul>
				</div> */}
			</div>
		</div>
	);
};

export default NavBar;
